export const AUTH_TOKEN = 'accessToken';
export const AUTH_USER = 'userInfo';
